import { PublicChannelService } from '@wix/wix-vod-gql-api/dist/src/public/channel/channel';
import { PublicVideoCardsService } from '@wix/wix-vod-gql-api/dist/src/public/video-cards/video-cards';
export var publicApiV3 = {};
export function initPublicServicesV3(authorization) {
    publicApiV3.channel = new PublicChannelService(authorization);
    publicApiV3.cards = new PublicVideoCardsService(authorization);
}
